import { useContentFiltering } from "@hub/services/use-content-filtering";
import { CustomCodeSampleAd } from "@hub/ui/ads/custom-code-sample-ad";
import { ReadyToSecureAd } from "@hub/ui/ads/ready-to-secure-ad";
import { DocumentCard } from "@hub/ui/cards/document-card";
import { Layouts } from "@hub/values/layout-values";
import React from "react";
import styles from "./search-results.module.css";

interface SearchResultsProps {
  enableCustomSampleWidget?: boolean;
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  enableCustomSampleWidget = true,
}) => {
  const { results } = useContentFiltering();

  if (!results) {
    return <div className={styles.results} />;
  }

  return (
    <div className={styles.results}>
      <div className={styles.results_list}>
        {results.length === 0 && (
          <div className={styles.noResults}>
            <span className={styles.noResults__title}>No results found.</span>
            <span className={styles.noResults__description}>
              Try checking filters or your search query and please try again!
            </span>
          </div>
        )}
        {results.length > 0 &&
          results.slice(0, 3).map((result) => {
            const key = `${result.path}_${result.type}_${result.framework}-${
              result.framework_version.number
            }_${result.language}_${result.vertical}${
              result.variant ? `_${result.variant}` : ""
            }`;

            return (
              <React.Fragment key={key}>
                {result.layout === Layouts.SAMPLE && (
                  <DocumentCard data={result} testName="code-sample" />
                )}
                {result.layout === Layouts.LAB && (
                  <DocumentCard data={result} testName="lab" />
                )}
                {result.layout === Layouts.GUIDE && (
                  <DocumentCard
                    data={result}
                    openNewTab={result.path.includes("auth0.com/blog")}
                    testName="guide"
                  />
                )}
              </React.Fragment>
            );
          })}

        {enableCustomSampleWidget && <CustomCodeSampleAd />}

        {results.length > 0 &&
          results.slice(3).map((result) => {
            const key = `${result.path}_${result.type}_${result.framework}-${
              result.framework_version.number
            }_${result.language}_${result.vertical}${
              result.variant ? `_${result.variant}` : ""
            }`;

            return (
              <React.Fragment key={key}>
                {result.layout === Layouts.SAMPLE && (
                  <DocumentCard data={result} testName="code-sample" />
                )}
                {result.layout === Layouts.GUIDE && (
                  <DocumentCard
                    data={result}
                    openNewTab={result.path.includes("auth0.com/blog")}
                    testName="guide"
                  />
                )}
              </React.Fragment>
            );
          })}
      </div>
      <ReadyToSecureAd />
    </div>
  );
};
